import { GOAL_TYPE_MAP } from "Components/Analyses/Goals/Timeline/utils/goalTypeTranslation";
import { GoalIcon } from "Components/Analyses/_Shared/Goals/GoalIcon";
import { TypeTile } from "Components/Analyses/_Shared/TypeTile";
import type { GoalOverviewType } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";

type Props = {
  readonly goalType: GoalOverviewType;
  readonly disabled?: boolean;
};

// One goal type in the drawer's RadioGroup, the same tile as the other type pickers.
export const GoalTile: FC<Props> = ({ goalType, disabled = false }) => {
  const { t } = useResource();
  const icon = <GoalIcon type={goalType} />;

  return (
    <TypeTile
      value={goalType}
      disabled={disabled}
      icon={icon}
      label={t(Resources.AnalysisDetail.Goals.GoalType[GOAL_TYPE_MAP[goalType]])}
    />
  );
};
